import {Requestor} from 'hegyd/core/resources/assets/js/utils/Requestor.js'
import {debounce} from "debounce";

export default class CartLineItem extends HTMLDivElement {
    productId;
    quantity;
    constructor() {
        super();

        this.returnTemplates = JSON.parse(this.dataset.returnTemplates ?? '[]');
        this.mainContainer = document.getElementById('cart-main-container');

        this.productId = this.dataset.productId;
        this.quantity = this.querySelector('input[name=\'product-count\']').value;
    }

    connectedCallback() {
        this.events();
    }

    // Initialisation events de la cart-line
    events() {
        let quantityInput = this.querySelector('input[name=\'product-count\']');

        /* Quantité up */
        this.querySelector('.quantity-up').addEventListener('click', debounce((e) => {
            e.preventDefault();

            this.quantity++;
            this.updateQuantity();
        },100));

        /* Quantité down */
        this.querySelector('.minus').addEventListener('click', debounce((e) => {
            e.preventDefault();

            if (quantityInput.value > 1) {
                this.quantity--;
                this.updateQuantity();
            }
        },100));

        quantityInput.addEventListener('keyup', debounce((e) => {
            e.preventDefault();

            this.quantity = quantityInput.value;

            if (isNaN(Number.parseInt(this.quantity))) {
                this.quantity = 1;
            }

            if (quantityInput.value < 1) {
                this.quantity = 1;
            }

            this.updateQuantity();
        },100));

        quantityInput.addEventListener('change', debounce((e) => {
            e.preventDefault();

            if (isNaN(Number.parseInt(quantityInput.value))) {
                quantityInput.value = 1;
            }

            this.quantity = quantityInput.value;
            this.updateQuantity();
        },100));

        /* Suppression d'une ligne du panier */
        this.querySelector('button.order-item-card-remove').addEventListener('click', debounce((e) => {
            e.preventDefault();

            this.deleteProduct(this.mainContainer );
        },100));
    }

    updateQuantity()
    {
        let quantityInput = this.querySelector('input[name=\'product-count\']');

        if (this.quantity != quantityInput.value && document.activeElement !== quantityInput) {
            quantityInput.value = this.quantity;
        }

        const requestor = new Requestor();

        requestor.sendRequest( this.dataset.route, 'PUT', {
            'product_id': this.productId,
            'cart_id' : this.dataset.cartId,
            'quantity': this.quantity,
            'return_templates': this.returnTemplates,
        }, (data) => {
            if ('cart_lines_list' in data.templates) {
                let newPriceHTML = new DOMParser().parseFromString(data.templates.cart_lines_list, "text/html").querySelector('[data-product-id="' + this.productId + '"]');

                if (newPriceHTML) {
                    newPriceHTML = newPriceHTML.querySelector('.desc .title span.price');

                    this.querySelector('.desc .title span.price').innerHTML = newPriceHTML.innerHTML;

                    if (document.activeElement !== quantityInput) {
                        quantityInput.value = this.quantity;
                    }

                    delete data.templates.cart_lines_list;
                }
            }

            this.mainContainer.updateCartViews(data);
        });
    }

    deleteProduct(container) {
        var item = this.querySelector("button.order-item-card-remove");
        var href = item.dataset.href;

        const requestor = new Requestor();

        container.askToDelete( item.dataset.message, item.dataset.button, item.dataset.cancelButton,( callback ) => {
            requestor.sendRequest( href, 'DELETE', {
                'product_id'        : this.dataset.productId,
                'user_id'           : this.dataset.userId,
                'cart_id'           : this.dataset.cartId,
                'return_templates'  : this.returnTemplates,
            }, (data) => {
                container.updateCartIndexViewAfterDeleteAProduct(data);
            });
        });
    }
}